// 업로드 전 사진 크기 줄이기: 휴대폰 원본(5~15MB)을 긴 변 2560px 로 줄여 전송 시간·서버 용량을 아낀다.
// 다시 인코딩하면서 위치정보 등 EXIF 도 제거된다. 줄여도 크기 이득이 없으면 원본을 그대로 쓴다.
const MAX_SIDE = 2560;
const MIN_BYTES = 1.2 * 1024 * 1024;
const QUALITY = 0.85;

const decode = async (file) => {
    if ('createImageBitmap' in window) {
        try { return await createImageBitmap(file, { imageOrientation: 'from-image' }); } catch {}
    }
    return new Promise((resolve, reject) => {
        const url = URL.createObjectURL(file);
        const img = new Image();
        img.onload = () => { URL.revokeObjectURL(url); resolve(img); };
        img.onerror = () => { URL.revokeObjectURL(url); reject(new Error('decode failed')); };
        img.src = url;
    });
};

const toBlob = (canvas, type, quality) => new Promise(resolve => canvas.toBlob(resolve, type, quality));

export async function compressImage(file) {
    const type = file.type;
    if (!/^image\/(jpeg|png|webp)$/.test(type) || file.size < MIN_BYTES) return file;
    try {
        const image = await decode(file);
        const width = image.width || image.naturalWidth;
        const height = image.height || image.naturalHeight;
        if (!width || !height) return file;
        const scale = Math.min(1, MAX_SIDE / Math.max(width, height));
        const canvas = document.createElement('canvas');
        canvas.width = Math.round(width * scale);
        canvas.height = Math.round(height * scale);
        canvas.getContext('2d').drawImage(image, 0, 0, canvas.width, canvas.height);
        image.close?.();

        // PNG 는 투명도를 지키기 위해 WebP 로, 나머지는 JPEG 로 저장 (WebP 인코딩을 못 하는 브라우저는 원본 유지)
        const targetType = type === 'image/png' ? 'image/webp' : 'image/jpeg';
        const blob = await toBlob(canvas, targetType, QUALITY);
        if (!blob || blob.type !== targetType || blob.size >= file.size * 0.9) return file;
        const ext = targetType === 'image/webp' ? 'webp' : 'jpg';
        const name = file.name.replace(/\.[^.]+$/, '') + '.' + ext;
        return new File([blob], name, { type: targetType, lastModified: file.lastModified });
    } catch {
        return file;
    }
}
